"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OFFER_NOTIFICATION_API_ERROR_CODES = exports.OnsFormAction = void 0;
var OnsFormAction;
(function (OnsFormAction) {
    OnsFormAction["CREATE"] = "CREATE";
    OnsFormAction["UPDATE"] = "UPDATE";
    OnsFormAction["DELETE"] = "DELETE";
})(OnsFormAction || (exports.OnsFormAction = OnsFormAction = {}));
/** Matches `OFFER_NOTIFICATION_ERROR_CODES` in backend validations (offer-notification-subscription). */
exports.OFFER_NOTIFICATION_API_ERROR_CODES = {
    REGISTERED_ACCOUNT: 'OFFER_NOTIFICATION_EMAIL_REGISTERED_ACCOUNT',
    EMAIL_ALREADY_SUBSCRIBED: 'OFFER_NOTIFICATION_EMAIL_ALREADY_SUBSCRIBED',
};
